import { render, staticRenderFns } from "./CardStatus.vue?vue&type=template&id=9c0a9e0a&scoped=true&"
import script from "./CardStatus.vue?vue&type=script&lang=js&"
export * from "./CardStatus.vue?vue&type=script&lang=js&"
import style0 from "./CardStatus.vue?vue&type=style&index=0&id=9c0a9e0a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c0a9e0a",
  null
  
)

export default component.exports